<template>
    <div class="systemTaskSearch">
        <Row :gutter="4">
            <Col span="4">
                <!-- v-on:input实时查询 -->
                <Input search v-model="systemTaskSearchKey" :placeholder="$t('configuration_management.system_task.searchByBeanName')" @on-search="searchBean()"/>
            </Col>
            <Col span="16">
                <add-system-task></add-system-task>
            </Col>
        </Row>
    </div>
</template>
<script>
    import AddSystemTask from '../system_task/AddSystemTask'
    import TableSystemTask from '../system_task/TableSystemTask'
    var tableSystemTask = TableSystemTask;
    export default {
        name: 'SystemTaskSearch',
        components: {
            AddSystemTask
        },
        data () {
            return {
                systemTaskSearchKey:'',
                systemTaskSearchName:''
            }
        },
        methods: {
            searchBean: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('systemTaskSearchName', this.systemTaskSearchKey);
                tableSystemTask.methods.showAll();
            }
            
        }
    }
</script>
<style scoped>
    .systemTaskSearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/system_task/SystemTaskSearch.vue